import React, { Fragment, useState, useContext, useEffect } from 'react';
import {
    Paper,
    Grid,
    Link,
    Select,
    MenuItem,
    Button,
    Typography,
    Dialog,
    DialogContent,
} from '@material-ui/core';
import { useStyles } from '../styles/Styles';
import 'date-fns';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import OTP from '../components/OTP/OTP';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import NumberFormat from 'react-number-format';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../components/header/Header';

const SelectScheduleSummary = () => {
    const classes = useStyles(); //Use Styles from styles/styles.js
    const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
    const notificationContext = useContext(NotificationContext);
    const {
        userInfo,
        setUserInfo,
        errors,
        clearErrors,
        loading,
        CheckifSoftLock,
        getApplicationDetails,
        applicationDetails,
        requestForOTP,
        otp_succ,
        otpRequest,
        getVideoCallSchedule,
        videoCallSchedule,
        selectedVideoCallSchedule,
        selectedDisplayVideoCallSchedule,
        nextStep,
        submitVideoCallSchedule
    } = documentUploadContext;

    const [dateTimeVideoCall, setDateTimeVideoCall] = useState('');

    const handleEditScheduleClick = (e) => {
        nextStep(0);
    };

    const handleSubmitClick = (e) => {
        submitVideoCallSchedule(applicationDetails.referenceNumber, selectedVideoCallSchedule);
    };

    useEffect(() => {
        if (errors != null) {
            notificationContext.setNotification(errors, 'error');
            clearErrors();
        }
    }, [userInfo, errors]);

    return (
        <div>
            <Header page={3} />
            <div className={classes.banner}>
                <Fragment>
                    <Typography className={classes.paragraph}>You have chosen the schedule below. Kindly confirm.</Typography>
                    <Paper elevation={0} className={classes.paper}>
                        <Notification />
                        {loading ? (
                            <Spinner />
                        ) : (
                                <Fragment>
                                    <Grid container justify='center' alignItems='center' >
                                        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                                            <p classes={classes.txtFldLbl}>Date and Time of Video Call</p>
                                            <h3>{selectedDisplayVideoCallSchedule}</h3>
                                        </Grid>
                                    </Grid>
                                    <Grid container justify='center'>
                                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3} ><Link underline='always' align='center' onClick={handleEditScheduleClick}><h3>Edit Schedule</h3></Link></Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} xl={3} >
                        <Button
                                style={{ textAlign: 'right' }}
                                className={classes.button}
                                variant='contained'
                                color='primary'
                                type='submit'
                                onClick={handleSubmitClick}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                                </Fragment>
                            )}
                    </Paper>
                </Fragment>
            </div>
        </div>
    );
};

export default SelectScheduleSummary;
